import Associate from './AssociateDetailController';

export default Associate;
